// [ai] Small helpers shared by the player: clamp, a cancellable debounce, the reduced-motion / touch / narrow answers (one place —
// three different tests used to disagree). NARROW_PX mirrors tokens.css --bp-narrow; keep both in step.
export const NARROW_PX = 899;
export const PHONE_PX = 640;
export function clamp(v: number, a: number, b: number): number { return Math.min(b, Math.max(a, v)); }
export type Debounced<A extends unknown[]> = ((...a: A) => void) & { cancel: () => void };
export function debounce<A extends unknown[]>(fn: (...a: A) => void, ms: number): Debounced<A> {
  let t: ReturnType<typeof setTimeout> | undefined;
  const f = ((...a: A) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }) as Debounced<A>;
  f.cancel = () => clearTimeout(t); return f;
}
const mq = (q: string) => typeof matchMedia === "function" && matchMedia(q).matches;
export const reducedMotion = () => mq("(prefers-reduced-motion: reduce)");
export const isTouch = () => mq("(pointer: coarse)");
export const isNarrow = () => mq(`(max-width: ${NARROW_PX}px)`);
export const isPhone = () => mq(`(max-width: ${PHONE_PX}px)`);
